import { render, staticRenderFns } from "./transactions.vue?vue&type=template&id=bc1d53c2&scoped=true&"
import script from "./transactions.vue?vue&type=script&lang=js&"
export * from "./transactions.vue?vue&type=script&lang=js&"
import style0 from "./transactions.vue?vue&type=style&index=0&id=bc1d53c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc1d53c2",
  null
  
)

export default component.exports